import type { GetStaticPaths } from 'next'
import { PillarPage, SearchPageCity } from 'src/constants/searchPages'
import Page, { getStaticProps } from './[hood]'

export default Page

export { getStaticProps }

/**
 * MONEY PAGES — prerendered at build so a deploy (which wipes the ISR cache)
 * never leaves a paid lander cold. Everything else renders on first hit via
 * `fallback: 'blocking'` (see the hood-level `getStaticPaths`).
 *
 * Keep this list SHORT and paid-driven: each entry is one backend search per
 * locale at build time. Current picks = the pages ad budgets actually land on
 * (2026-08-29 lander move: PMax + competitors → MTY storage) plus the
 * organic/paid cores.
 */
const MONEY_PAGES: Array<{ pillar: PillarPage; city: SearchPageCity }> = [
  { pillar: PillarPage.SelfStorage, city: SearchPageCity.Monterrey },
  { pillar: PillarPage.SelfStorage, city: SearchPageCity.CiudadDeMexico },
  { pillar: PillarPage.SelfStorage, city: SearchPageCity.Guadalajara },
  { pillar: PillarPage.Parking, city: SearchPageCity.Monterrey },
  { pillar: PillarPage.Parking, city: SearchPageCity.CiudadDeMexico }
]

export const getStaticPaths = (async ({ locales = [] }) => {
  return {
    paths: locales.flatMap((locale) =>
      MONEY_PAGES.map(({ pillar, city }) => ({
        params: { pillar, city },
        locale
      }))
    ),
    fallback: 'blocking'
  }
}) satisfies GetStaticPaths
